import React, { useEffect, useState, Suspense} from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet"

import '../App.css';
import '../lib/styles.css';

import Header from "./c/Header";
import Footer from "./c/Footer";
import NavBar from "./c/NavBar";
import SearchBar from "./c/SearchBar";
import Filters from "./c/Filters";
import SongListTable from "./c/SongListTable";
import Summary from "./c/Summary";

import apiUrl from "../lib/api"
import apiHeader from "../lib/apiHeader";

import { useFooter } from "../lib/varFooter";
import { useSongList } from "../lib/varSongList";
import { useHeader } from "../lib/varHeader";
import { useFilter } from "../lib/varFilter";
import { useSummary } from "../lib/varSummary";

type PageParams = {
  pageNo: any;
}

const Page: React.FC = () => {
  const [currentUrl, setCurrentUrl] = useState<string>('');
  let { pageNo } = useParams<PageParams>();

    const { setData } = useSongList();
    const { setFooter } = useFooter();
    const { setHeader } = useHeader();
    const { setSummary } = useSummary();
    const { setFilter } = useFilter();
    const { data } = useSongList();
    const { header } = useHeader();
    const { filter } = useFilter();

    const today = new Date();
    const year = today.getFullYear();

    let pageSize: number;
    let startYear: number|undefined;
    let endYear: number|undefined;
    let q: string|undefined;
    filter.page_size ? pageSize = filter.page_size : pageSize = 20
    filter.start_year ? startYear = filter.start_year : startYear = 1887
    filter.end_year ? endYear = filter.end_year : endYear = year

    if(startYear<1888) {startYear = undefined}
    if(endYear>(year-1)) {endYear = undefined}
    
    async function fetchSongListInfo() {
      try {
        q = filter.q
        if(q==="") { q = undefined }
        const dataToSend = {
          page: pageNo,
          q: q,
          limit: pageSize,
          sort_by: filter.sort_by,
          start_year: startYear,
          end_year: endYear,
        }
        // console.log(dataToSend)
        const result = await fetch(apiUrl,{method: "POST", headers: apiHeader, body: JSON.stringify(dataToSend)});
        const datafromresult = await result.json();
        // const empty = [null]
        // setData((prev) => ({ ...prev, ...empty }))
        setData((prev) => ({ ...prev, ...datafromresult}))
        const footer = {
            api_version: datafromresult['version'],
            api_license: datafromresult['license'],
            api_license_url: datafromresult['license_url'],
            api_attribution: datafromresult['attribution'],
            api_server_name: datafromresult['servername'],
            api_server_time: datafromresult['time'],
        }
        setFooter((prev) => ({ ...prev, ...footer}))
        const header = {
            page_size: pageSize,
            max_page: Math.ceil(datafromresult['totalFound']/pageSize),
            current_list_page: parseInt(pageNo,10),
            current_loaded_page: datafromresult['page'],
            page_sort_order: filter.sort_by,
        }
        setHeader((prev) => ({ ...prev, ...header }))
        const summary = {
          totalFound: datafromresult['totalFound'],
          totalSongs: datafromresult['totalSongs'],
          availableSongs: datafromresult['availableSongs'],
          totalArtists: datafromresult['totalArtists'],
          totalAlbums: datafromresult['totalAlbums'],
          totalArrangements: datafromresult['totalArrangements'],
          AIArrangements: datafromresult['totalAIArrangements'],
          AuthArrangements: datafromresult['totalPlayableArrangements'],
          arrangements: datafromresult.arrangements,
          publishers: datafromresult.publishers,
          courtesy: datafromresult.courtesy,
          genres: datafromresult.genre,
        }
        setSummary((prev) => ({ ...prev, ...summary}))
        const newFilter = {
          page_size: pageSize
        }
        setFilter((prev) => ({ ...prev, ...newFilter}))

      } catch (error) {
        console.log('fetchSongListInfo() ERROR => ', error)
      }
    }
  
    useEffect(() => {
        fetchSongListInfo();
    }, [pageNo, filter.q, filter.sort_by])
    useEffect(() => {
    try {
        const header = {
            current_list_page: parseInt(pageNo,10),
        }
        setHeader((prev) => ({ ...prev, ...header}))
    } catch (error) {
        // console.log("this didn't work")
    }
    }, [pageNo])

    useEffect(() => {
      setCurrentUrl(window.location.href)
  }, []);
  
    return (
        <div className="App">
          <Helmet>
            <title>{`Rocksmith+ Songs List`}</title>
            <meta name="keywords" content="" />
            <meta name="description" content="Rocksmith+ complete library songlist" />
            <meta property="og:title" content="Rocksmith+ Songs List"/>
            <meta property="og:image" content="/rs+/img/VPNSmith.png"/>
            <meta property="og:url" content={currentUrl}/>
            <meta property="og:description" content="Rocksmith+ complete library songlist"/>
            <meta name="twitter:title" content="Rocksmith+ Songs List" />
            <meta name="twitter:description" content="Rocksmith+ complete library songlist"/>
            <meta name="twitter:image" content="/rs+/img/VPNSmith.png" />
          </Helmet>
          <Header />
          {header.viewSearch ? <SearchBar /> : null }
          {header.viewFilter ? <Filters /> : null }
          <NavBar />
          {data.data ? <Suspense fallback={<div>Loading....</div>}><SongListTable data={data.data} myRegion={""} searchRegion={""} /></Suspense> : null }
          <NavBar />
          <Summary />
          <Footer />
        </div>
    )
}

export default Page;
